import type { InfoScreenPage } from "@/types/infoScreen";

export function usesPageShowImageRotation(page: InfoScreenPage): boolean {
  if (page.layout === "full_bleed" || page.layout === "image_focus") {
    return page.images.length > 1;
  }
  if (page.layout === "columns") {
    return page.images.length > 1;
  }
  return false;
}

export function nextImageIndex(current: number, imageCount: number): number {
  if (imageCount <= 0) return 0;
  return (current + 1) % imageCount;
}

export function advancePageImageIndex(
  indices: Record<string, number>,
  page: InfoScreenPage,
): void {
  if (!usesPageShowImageRotation(page)) return;
  indices[page.id] = nextImageIndex(indices[page.id] ?? 0, page.images.length);
}
